import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import classes from '../components/subscriberInfoCard.module.css'

export default function SubscriberInfoCard(props) {
  const [open, setOpen] = React.useState(false);
  const [showRaw, setShowRaw] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const dailyBalance= props.cardData.daily_spending_limit
  const totalAmount = props.cardData.amount

  return (
    <React.Fragment>
      
      <Dialog
        open={props.openCard}
        onClose={props.closeCard}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
          {"Subscriber's Balance & Information"}
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <DialogContentText id="alert-dialog-description" className={classes.dialogContentText}>
           <div className={classes.infoRow}>
            <span className={classes.label}>Name:</span>
            <span className={classes.value}>{props.cardData.firstname} {props.cardData.lastname}</span>
           </div>
           <div className={classes.infoRow}>
            <span className={classes.label}>Day's Balance:</span>
            <span className={classes.value}>GHC {props.cardData.current_balance ? parseFloat(props.cardData.current_balance).toFixed(2) : '0.00'}</span>
           </div>
           <div className={classes.infoRow}>
            <span className={classes.label}>Spending Limit:</span>
            <span className={classes.value}>GHC {dailyBalance ? parseFloat(dailyBalance).toFixed(2) : '0.00'}</span>
           </div>
           <div className={classes.infoRow}>
            <span className={classes.label}>Total Balance:</span>
            <span className={classes.value}>GHC {totalAmount ? parseFloat(totalAmount).toFixed(2) : '0.00'}</span>
           </div>
           <div className={classes.infoRow}>
            <span className={classes.label}>Meal Plan Funder:</span>
            <span className={classes.value}>{props.cardData.meal_plan_name || '-'}</span>
           </div>
          </DialogContentText>
          {/* Raw JSON for debugging / full response */}
          {showRaw && (
            <pre className={classes.rawJson} style={{whiteSpace:'pre-wrap', wordBreak:'break-word', marginTop:12}}>{JSON.stringify(props.cardData, null, 2)}</pre>
          )}
        </DialogContent>
        <DialogActions>
          
          <Button onClick={props.closeCard} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
